import type { PropsWithChildren } from "react";
import type { Props } from "./MetricsPageContext";
import { MetricsPageContext } from "./MetricsPageContext";

export const MetricsPageContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <MetricsPageContext value={props}>{children}</MetricsPageContext>
);
